<template>
  <div id="store-gift">
    <NavFooter />
    <div class="empty" v-if="data === undefined">
      <InlineLoading />
    </div>
    <Empty v-else-if="!data" title="暂无优学卡" subtitle="您还没有在店内购买优学卡" />
    <div v-else>
      <Card :version="version" :event="event" :img="event.img" :gift="gift" />
      <Progress v-if="version === 2 || version === 3" :current="data.status" />
      <Progress
        v-if="version === 4"
        :current="data.status"
        :steps="{
          0: '店内开卡',
          0.5: '预约上课',
          1: '开始上课',
          2: '兑换礼品',
        }"
      />
      <!-- 课程 -->
      <div class="content">
        <div class="tip">感谢您在{{ data.store_a.name }}解锁优学卡，获得以下权益：</div>
        <div class="gift">
          <div class="text">
            <div class="title">
              <div class="title-left">线上体验课</div>
            </div>
            <div v-if="is2">
              <div class="subtitle" v-if="data.status === 0">请先完成预约并上课，然后收到礼品码</div>
              <!-- <div class="subtitle" v-if="data.status === 0.5">上课后将收到礼品码</div> -->
            </div>
          </div>
          <div class="item">
            <div class="item-left">
              <div class="item-left-title">{{ event.course_name }}</div>
              <div class="item-left-subtitle item-left-remark">250 小时学完中学六年全部英语</div>
              <router-link
                tag="div"
                to="/courses?type=109&source=store-gift"
                class="item-left-subtitle item-link"
              >了解更多</router-link>
            </div>
            <div class="item-right">
              <div class="item-right-price">{{ event.course_price }}</div>
              <div class="item-right-unit">元</div>
            </div>
          </div>
          <div v-if="data.status === 0">
            <div v-if="version === 4" @click="components.course = true" class="contact">立即预约</div>
            <div v-else @click="state.contact = true" class="contact">立即预约</div>
          </div>
          <div v-if="data.status > 0 && version >= 4" class="after-order">
            <div v-if="data.status === 0.5" @click="state.contact = true" class="contact">
              <p>
                <!-- <i class="anyteachicon anyteach-check-circle" /> -->
                <i class="anyteachicon anyteach-headset" />
                <span>联系客服</span>
              </p>
              <p class="hint">请在 {{ contactDeadline }} 前与客服确认试听时间</p>
            </div>
            <router-link
              :to="'/order/view?order_id=' + data.order.order_id"
              tag="p"
              class="order"
            >查看预约订单</router-link>
          </div>
        </div>
        <!-- 门店 -->
        <div class="gift" v-if="data.store_a">
          <div class="text">
            <div class="title">
              <div class="title-left">{{ data.store_a.name }}</div>
              <div class="title-right" @click="showStoreInfo(data.store_a)">查看门店详情</div>
            </div>
            <div class="subtitle" v-if="!is2">请凭礼品券在有效期内前往店内免费领取</div>
            <div v-else>
              <div class="subtitle" v-if="data.status < 1">完成 1 次课程后将收到礼品码</div>
              <div class="subtitle" v-else>请凭礼品码在有效期内前往店内兑换</div>
            </div>
          </div>
          <div class="item" v-for="(key, index) in parseInt(gift.num)" :key="key">
            <div class="item-left">
              <div class="item-left-title">{{ gift.name }}</div>
              <div v-if="is2">
                <div v-if="data.coupon.length" class="item-left-subtitle item-left-remark">
                  有效期：{{ $moment(data.coupon[index].start_time).format("MM/DD") }} -
                  {{ $moment(data.coupon[index].end_time).format("MM/DD") }}
                </div>
                <div v-if="data.status < 1" class="item-left-subtitle item-left-remark">等待礼品码</div>
                <div v-else class="item-left-subtitle">
                  <span class="item-left-remark" v-if="key <= usedCoupons">
                    <i class="anyteachicon anyteach-check-circle" />已兑换
                  </span>
                  <span
                    v-else-if="today.isBefore(data.coupon[index].start_time)"
                    class="item-left-remark"
                  >{{ $moment(data.coupon[index].start_time).diff(today, "day") + 1 }} 天后生效</span>
                  <span
                    v-else-if="
                      today.isAfter(data.coupon[index].start_time) &&
                        today.isBefore(data.coupon[index].end_time)
                    "
                    class="item-link"
                    @click="state.couponId = data.coupon[index].id"
                  >查看礼品码</span>
                  <span
                    v-else-if="today.isAfter(data.coupon[index].end_time)"
                    class="item-left-remark"
                  >已过期</span>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item-right-price">{{ gift.price }}</div>
              <div class="item-right-unit">元</div>
            </div>
          </div>
        </div>
        <router-link
          v-if="event.ad_img"
          tag="div"
          class="ad"
          to="/store-gift/apply?source=customer"
        >
          <img :src="event.ad_img" />
        </router-link>
      </div>
      <Modal
        v-if="components.course"
        v-on:dismiss="components.course = false"
        title="预约课程"
        subtitle="根据孩子年龄选择"
        :showComplete="false"
        :showClose="true"
        :tapToDismiss="true"
      >
        <Course
          :data="data"
          v-on:complete="getData(); components.course = false; state.contact = true"
        />
      </Modal>
      <Modal
        v-if="state.info"
        v-on:dismiss="state.info = false"
        title="门店详情"
        :showComplete="false"
        :showClose="true"
        :tapToDismiss="true"
      >
        <StoreInfo :store="storeInfo" />
      </Modal>
      <Modal
        v-if="state.couponId"
        v-on:dismiss="state.couponId = null"
        :showComplete="true"
        :showClose="true"
        :tapToDismiss="true"
      >
        <Code :id="state.couponId" />
      </Modal>
      <keep-alive>
        <Modal
          v-if="state.contact"
          v-on:dismiss="state.contact = false"
          title="试听须知"
          :showComplete="false"
          :showClose="true"
          :tapToDismiss="true"
        >
          <Info v-if="version >= 4" :date="contactDeadline" />
          <CustomerService :order_id="data.status > 0 ? data.order.order_id : null" />
        </Modal>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import NavFooter from "@/components/public/footer"
import Modal from "@/components/popup/Modal"
import Empty from "@/components/public/Empty"
import Progress from "./Progress"
import Card from "./Card"
import Code from "./Code"
import StoreInfo from "./StoreInfo"
import Course from "./Course"
import CustomerService from "@/components/public/CustomerService"
import Info from "./Info"

export default {
  name: "CardList",
  components: {
    NavFooter,
    Empty,
    Modal,
    Progress,
    Card,
    Code,
    StoreInfo,
    Course,
    CustomerService,
    Info
  },
  data() {
    return {
      data: undefined,
      today: this.$moment(),
      state: {
        contact: false,
        info: false,
        couponId: null,
      },
      components: {
        course: false
      },
      storeInfo: null
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    version() {
      return this.data ? this.data.store_a.type : null
    },
    event() {
      return this.data ? this.data.store_a.event_info : null
    },
    is2() {
      return this.version >= 2
    },
    gift() {
      return this.data ? this.data.store_a.gift[0] : null
    },
    usedCoupons() {
      if (!this.is2) return 0
      return this.data.coupon.filter(item => item.status === 1).length
    },
    query() {
      return this.$route.query
    },
    contactDeadline() {
      if (!this.data.order) return null
      return this.$moment(this.data.order.pay_time).add(2, "day").format("YYYY-MM-DD 00:00")
    }
  },
  methods: {
    showStoreInfo(info) {
      this.storeInfo = info
      this.state.info = true
    },
    async getData() {
      const params = this.query.store_id ?
        {
          store_id: this.query.store_id
        } : {
          phone: this.user.mobile
        }
      let { code, msg } = await this.$api.storeGift.CARD(params)
      if (code === "1000" || code === "1001") {
        this.data = msg
      } else if (code === "2002") {
        this.data = null
      } else {
        this.$toast(msg)
      }
      if (code === "1000") {
        setTimeout(() => {
          this.components.course = true
        }, 1000)
      }
      if (code === "1000" && this.version < 4) {
        this.$toast("请将页面出示给店员")
      }
    },
  },
  async mounted() {
    if (!this.user.user_id) {
      const { code, msg } = await this.$api.user.PROFILE()
      if (code === "1000") {
        this.$store.commit("user", msg)
      }
    }
    if (this.user && this.user.mobile) {
      this.getData()
    }
    if (this.user.user_id && !this.user.mobile && this.$store.state.isWechat) {
      const config = {
        path: "/login",
        query: {
          from: this.$route.fullPath,
          hint: 1,
        },
      }
      const checkQuery = key => {
        if (this.$route.query[key]) {
          config.query[key] = this.$route.query[key]
        }
      }
      checkQuery("phone")
      this.$router.replace(config)
    }
  },
}
</script>

<style lang="scss" scoped>
#store-gift {
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  margin: 20px 0;
  width: 100%;
  background: white;
  font-family: Avenir, -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji,
    Segoe UI Symbol;
  i {
    font-weight: 400 !important;
  }
  .content {
    padding: 0 5%;
  }
  .tip {
    font-size: 0.8rem;
    width: 100%;
    text-align: center;
    margin: 10px 0 0 0;
  }
  .ad {
    padding-top: 10px;
    border-top: 1px solid #eee;
    margin-bottom: -10px;
    transition: all 0.1s;
    &:active {
      opacity: 0.6;
    }
    img {
      width: 100%;
      border-radius: 4px;
    }
  }
  .gift {
    margin: 5px 0 20px 0;
    .text {
      margin: 0 0 5px 0;
      .subtitle {
        opacity: 0.6;
        font-size: 0.8rem;
      }
    }
    .contact {
      width: 100%;
      font-weight: bold;
      text-align: center;
      background: $blue;
      border-radius: 4px;
      padding: 8px 0;
      color: white;
      font-size: 0.85rem;
      transition: all 0.1s;
      i {
        margin-right: 3px;
      }
      &:active {
        opacity: 0.6;
      }
      * {
        color: white;
      }
    }
    .title {
      font-size: 0.9rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title-left,
      .title-right {
        font-weight: bold;
      }
      .title-right {
        font-size: 0.8rem;
        color: $blue;
      }
    }
    .item {
      background: #f7f7f7;
      margin: 0 0 10px 0;
      border-radius: 4px;
      padding: 0 15px;
      height: 65px;
      border: $border;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .item-left {
      .item-left-title {
        font-weight: 500;
        font-size: 0.9rem;
      }
      .item-left-subtitle {
        font-size: 0.8rem;
        display: block;
        line-height: 1.4;
      }
      .item-left-remark {
        opacity: 0.6;
        i {
          margin-right: 3px;
        }
      }
      .item-link {
        color: $blue;
        transition: all 0.1s;
        &:active {
          opacity: 0.6;
        }
        i {
          margin-right: 3px;
        }
      }
    }
    .item-right {
      color: $blue;
      display: flex;
      align-items: top;
      padding-left: 10px;
      .item-right-price {
        font-size: 1.25rem;
        margin-right: 2px;
        font-weight: bold;
      }
      .item-right-unit {
        font-size: 0.8rem;
        transform: translateY(-1px);
      }
    }
  }

  .after-order {
    .contact {
      .hint {
        font-weight: 400;
        font-size: 0.8rem;
        margin-bottom: -3px;
      }
    }
    .order {
      text-align: center;
      color: $blue;
      transition: all 0.1s;
      font-size: 0.85rem;
      padding: 5px 0 0 0;
      margin: 0 0 -5px;
      &:active {
        opacity: 0.6;
      }
    }
  }
}

.empty {
  height: 80vh;
}
.animated {
  animation-delay: 0s !important;
  animation-duration: 0.5s !important;
}
</style>
